import { PublicKey } from '@solana/web3.js';

export const PROGRAM_ID = new PublicKey('CpHzGi7WrnsY8N9BVHdSkqdX8BuaTSW8QRGywrLSBSAh');

// IDL in the new Anchor 0.30+ format
export const IDL = {
  address: 'CpHzGi7WrnsY8N9BVHdSkqdX8BuaTSW8QRGywrLSBSAh',
  metadata: {
    name: 'poker_contract',
    version: '0.1.0',
    spec: '0.1.0',
  },
  instructions: [
    {
      name: 'createGame',
      discriminator: [124, 69, 75, 66, 184, 220, 72, 206],
      accounts: [
        { name: 'game', writable: true, pda: { seeds: [{ kind: 'const', value: [103, 97, 109, 101] }, { kind: 'arg', path: 'gameId' }] } },
        { name: 'creator', writable: true, signer: true },
        { name: 'systemProgram', address: '11111111111111111111111111111111' },
      ],
      args: [
        { name: 'gameId', type: 'u64' },
        { name: 'buyIn', type: 'u64' },
      ],
    },
    {
      name: 'joinGame',
      discriminator: [107, 112, 18, 38, 56, 173, 60, 128],
      accounts: [
        { name: 'game', writable: true },
        { name: 'player', writable: true, signer: true },
        { name: 'systemProgram', address: '11111111111111111111111111111111' },
      ],
      args: [],
    },
    {
      name: 'commitHand',
      discriminator: [45, 132, 189, 45, 56, 78, 167, 234],
      accounts: [
        { name: 'game', writable: true },
        { name: 'playerChoice', writable: true, pda: { seeds: [{ kind: 'const', value: [99, 104, 111, 105, 99, 101] }, { kind: 'account', path: 'game' }, { kind: 'account', path: 'player' }] } },
        { name: 'player', writable: true, signer: true },
        { name: 'systemProgram', address: '11111111111111111111111111111111' },
      ],
      args: [
        { name: 'handHash', type: { array: ['u8', 32] } },
      ],
    },
    {
      name: 'placeBet',
      discriminator: [222, 62, 67, 220, 63, 166, 126, 33],
      accounts: [
        { name: 'game', writable: true },
        { name: 'playerChoice', writable: true },
        { name: 'player', writable: true, signer: true },
        { name: 'systemProgram', address: '11111111111111111111111111111111' },
      ],
      args: [
        { name: 'amount', type: 'u64' },
      ],
    },
    {
      name: 'fold',
      discriminator: [94, 76, 89, 233, 45, 121, 178, 54],
      accounts: [
        { name: 'game', writable: true },
        { name: 'playerChoice', writable: true },
        { name: 'player', writable: true, signer: true },
      ],
      args: [],
    },
    {
      name: 'revealCommunity',
      discriminator: [178, 45, 89, 134, 67, 211, 98, 156],
      accounts: [
        { name: 'game', writable: true },
        { name: 'authority', signer: true },
      ],
      args: [
        { name: 'cards', type: { array: ['u8', 5] } },
        { name: 'count', type: 'u8' },
      ],
    },
    {
      name: 'settleGame',
      discriminator: [200, 134, 67, 45, 89, 123, 178, 234],
      accounts: [
        { name: 'game', writable: true },
        { name: 'authority', signer: true },
      ],
      args: [
        { name: 'winnerKey', type: 'pubkey' },
      ],
    },
    {
      name: 'claimWinnings',
      discriminator: [156, 89, 45, 234, 67, 178, 123, 200],
      accounts: [
        { name: 'game', writable: true },
        { name: 'winner', writable: true, signer: true },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: 'Game',
      discriminator: [27, 90, 166, 125, 74, 100, 121, 18],
    },
    {
      name: 'PlayerChoice',
      discriminator: [45, 178, 234, 89, 67, 156, 123, 200],
    },
  ],
  types: [
    {
      name: 'Game',
      type: {
        kind: 'struct',
        fields: [
          { name: 'gameId', type: 'u64' },
          { name: 'creator', type: 'pubkey' },
          { name: 'buyIn', type: 'u64' },
          { name: 'pot', type: 'u64' },
          { name: 'player1', type: { option: 'pubkey' } },
          { name: 'player2', type: { option: 'pubkey' } },
          { name: 'status', type: { defined: { name: 'GameStatus' } } },
          { name: 'currentBet', type: 'u64' },
          { name: 'player1Committed', type: 'bool' },
          { name: 'player2Committed', type: 'bool' },
          { name: 'communityCards', type: { array: ['u8', 5] } },
          { name: 'communityRevealed', type: 'u8' },
          { name: 'winner', type: { option: 'pubkey' } },
          { name: 'bump', type: 'u8' },
        ],
      },
    },
    {
      name: 'PlayerChoice',
      type: {
        kind: 'struct',
        fields: [
          { name: 'player', type: 'pubkey' },
          { name: 'game', type: 'pubkey' },
          { name: 'handHash', type: { array: ['u8', 32] } },
          { name: 'betAmount', type: 'u64' },
          { name: 'folded', type: 'bool' },
          { name: 'bump', type: 'u8' },
        ],
      },
    },
    {
      name: 'GameStatus',
      type: {
        kind: 'enum',
        variants: [
          { name: 'WaitingForPlayer' },
          { name: 'Dealing' },
          { name: 'Betting' },
          { name: 'Showdown' },
          { name: 'Finished' },
        ],
      },
    },
  ],
  errors: [
    { code: 6000, name: 'GameNotJoinable', msg: 'Game is not joinable' },
    { code: 6001, name: 'CannotJoinOwnGame', msg: 'Cannot join your own game' },
    { code: 6002, name: 'InvalidGameStatus', msg: 'Invalid game status for this action' },
    { code: 6003, name: 'NotAPlayer', msg: 'Not a player in this game' },
    { code: 6004, name: 'NotBettingPhase', msg: 'Not in betting phase' },
    { code: 6005, name: 'PlayerFolded', msg: 'Player has folded' },
    { code: 6006, name: 'InvalidCardCount', msg: 'Invalid card count' },
    { code: 6007, name: 'InvalidWinner', msg: 'Invalid winner' },
    { code: 6008, name: 'GameNotFinished', msg: 'Game not finished' },
    { code: 6009, name: 'NotWinner', msg: 'Not the winner' },
    { code: 6010, name: 'AlreadyClaimed', msg: 'Already claimed' },
  ],
};
